/**
 * Redessine le site quand les préférences d'affichage ou les taux de change changent, et les
 * synchronise avec le compte à la connexion.
 */

import { useEffect, type ReactNode } from 'react'
import { ensureExchangeRates, useExchangeRates, useFormat } from '../shared/format'
import { AUTH_TOKENS_CHANGED_EVENT } from '../features/auth/utils/tokenStorage'
import { pullFormatPreferences } from '../features/auth/utils/formatSync'

export function FormatRoot({ render }: { render: () => ReactNode }) {
  const format = useFormat()
  useExchangeRates()

  useEffect(() => {
    const pull = () => void pullFormatPreferences().catch(() => undefined)
    pull()
    window.addEventListener(AUTH_TOKENS_CHANGED_EVENT, pull)
    return () => window.removeEventListener(AUTH_TOKENS_CHANGED_EVENT, pull)
  }, [])

  useEffect(() => {
    void ensureExchangeRates()
  }, [format.currency])

  return <>{render()}</>
}
